// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3fedH","sendOtp":"AuthorizeToLogin_sendOtp__2atup"};